import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Tag } from "./Tag";

@Entity({one: "tagSet", many: "tagSets"})
export default class TagSet {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public sortIndex: number;

	@Field({entity: Tag})
	public tags: Tag[];

}



// WEBPACK FOOTER //
// ./src/panels/tags/entities/TagSet.ts